import {createApp} from 'vue'
import StafetRoundCounter from './StafetRoundCounter'

const el = '.kb-component--stafet-round-counter'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetRoundCounterDOM)=>{

            const rute = StafetRoundCounterDOM.dataset.data
                    ? JSON.parse(StafetRoundCounterDOM.dataset.data)
                    : null
            
            const maxRegistrationCount = StafetRoundCounterDOM.dataset.maxRegistrationCount

            const component = createApp(StafetRoundCounter, {rute, maxRegistrationCount}).use(Store)
            component.mount(StafetRoundCounterDOM)
        })
    }
}